declare namespace $ {

	type $mol_string__hint_bog_merchquarium_tags_1 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_tags['input_hint'] >
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_merchquarium_tags_2 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_tags['draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_bog_merchquarium_tags_3 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_tags['submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_button_major__title_bog_merchquarium_tags_4 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_tags['add_title'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_merchquarium_tags_5 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_tags['submit'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_row__sub_bog_merchquarium_tags_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_view__sub_bog_merchquarium_tags_7 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_tags['rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_merchquarium_tags_8 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_tags['name'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__hint_bog_merchquarium_tags_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_bog_merchquarium_tags_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_merchquarium_tags_11 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_tags['remove'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_paragraph__title_bog_merchquarium_tags_12 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_tags['confirm_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_merchquarium_tags_13 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_tags['confirm_info'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_merchquarium_tags_14 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_tags['usage_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__title_bog_merchquarium_tags_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_merchquarium_tags_16 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_tags['cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_major__title_bog_merchquarium_tags_17 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_tags['confirm_action'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_merchquarium_tags_18 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_tags['confirm'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_row__sub_bog_merchquarium_tags_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_pop__showed_bog_merchquarium_tags_20 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_tags['confirming'] >
		,
		ReturnType< $mol_pop['showed'] >
	>
	type $mol_pop__Anchor_bog_merchquarium_tags_21 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_tags['Remove_button'] >
		,
		ReturnType< $mol_pop['Anchor'] >
	>
	type $mol_pop__bubble_content_bog_merchquarium_tags_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop['bubble_content'] >
	>
	type $mol_row__sub_bog_merchquarium_tags_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	export class $bog_merchquarium_tags extends $mol_view {
		draft( next?: string ): string
		submit( next?: any ): any
		Input( ): $mol_string
		Add( ): $mol_button_major
		Form( ): $mol_row
		rows( ): readonly(any)[]
		List( ): $mol_view
		content( ): readonly(any)[]
		name( id: any): string
		Name( id: any): $mol_paragraph
		confirming( id: any, next?: boolean ): boolean
		Remove_icon( id: any): $mol_icon_close
		remove( id: any, next?: any ): any
		Remove_button( id: any): $mol_button_minor
		Confirm_title( id: any): $mol_paragraph
		Confirm_info( id: any): $mol_paragraph
		usage_text( id: any): string
		Confirm_count( id: any): $mol_paragraph
		cancel( id: any, next?: any ): any
		Cancel( id: any): $mol_button_minor
		confirm( id: any, next?: any ): any
		Confirm( id: any): $mol_button_major
		Confirm_actions( id: any): $mol_row
		Remove( id: any): $mol_pop
		items( ): readonly(string)[]
		editable( ): boolean
		input_hint( ): string
		marker( ): string
		add_title( ): string
		confirm_title( ): string
		confirm_info( ): string
		confirm_action( ): string
		usage( id: any): number
		item_add( id: any, next?: any ): any
		item_drop( id: any, next?: any ): any
		sub( ): ReturnType< $bog_merchquarium_tags['content'] >
		Row( id: any): $mol_row
	}
	
}

//# sourceMappingURL=tags.view.tree.d.ts.map